import * as FE from 'froala-editor';

(function ($) {
    var modal,
        overlay,
        currentEditor,
        editors = [];

    FE.PLUGINS.skoletube = function skoletube(editor) {
        editors.push(editor);

        // Create the modal, and inject it into the DOM
        if (!modal) {
            modal = document.createElement("div");

            modal.className = "fr-modal";
            modal.style.display = "none";

            modal.innerHTML = (
                '<div class="fr-modal-wrapper" style="padding-bottom:0;">' +
                    '<div class="fr-modal-head">' +
                        '<div class="fr-modal-head-line">' +
                            '<h4 data-text="true">' + editor.language.translate('Indsæt indhold fra Skoletube') + '</h4>' +
                        '</div>' +
                        '<button title="Fortryd" class="fr-command fr-btn fr-modal-close">' +
                            '<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 24 24"><path d="M13.4,12l5.6,5.6L17.6,19L12,13.4L6.4,19L5,17.6l5.6-5.6L5,6.4L6.4,5l5.6,5.6L17.6,5L19,6.4L13.4,12z"></path></svg>' +
                        '</button>' +
                    '</div>' +
                    '<div class="fr-modal-embed" style="padding-top:57px;">'+
                    '</div>' +
                '</div>'
            );

            document.body.appendChild(modal);

            // Add desktop-class if required
            if (!editor.helpers.isMobile()) {
                modal.classList.add("fr-desktop");
            }

            // Add event listeners to add support for closing the overlay
            modal.addEventListener("click", hide);

            modal.querySelector(".fr-modal-wrapper").addEventListener("click", function (evt) { evt.stopPropagation(); });
            modal.querySelector(".fr-modal-close").addEventListener("click", hide);
        }

        // Inject the overlay behind the rest of the body content
        if (!overlay) {
            overlay = document.createElement("div");

            overlay.className = "fr-overlay";
            overlay.style.display = "none";

            document.body.appendChild(overlay);

            // Add event listeners to add support for closing the overlay
            overlay.addEventListener("click", hide);
        }

        // Listen to focus-events, so we can update the currently active editor
        editor.events.on('focus', function () {
            currentEditor = editor;
        });
    };

    // Helper-method that hides the overlay...
    function hide() {
        overlay.style.display = "none";
        modal.style.display = "none";
        modal.querySelector(".fr-modal-embed").innerHTML = "";
    }

    // Load the helper from Skoletube, that will handle injecting media
    $.receiveMessage(function (e) {
        // Prepare the output
        if (typeof e.data === 'string' && e.data.match(/^https?\:\/\/www\.skoletube\.dk\/e\/[0-9a-f]*\//i)) {
            var editor = currentEditor || editors[0];
            var embed_code = '<iframe class="gfr-skoletube" src="' + e.data +'" width="480" height="390" frameborder="0" allowfullscreen allowTransparency="true"></iframe>';

            // Inject the iframe into the editor
            editor.commands.exec('videoInsertEmbed', [embed_code]);

            // Hide the overlay
            hide();
        }
    });

    FE.DefineIcon('insertSkoletube', {PATH: 'M15.574 15.277v.246c-.308-.02-.418-.117-.672-.187v.117c.118.098.168.149.118.246-.067.047-.06.04-.188.059-.078-.137-.168-.285-.246-.422-.137.07-.207.125-.363.187v.059c.336.02.46.117.668.246-.02.059-.04.117-.059.192-.531-.012-.117.156-.668.187-.101-.168-.195-.316-.422-.363-.347.336-.996.543-1.644.55-.09-.175-.07-.195-.309-.246-.215.168-.578.207-.855.305-.512 1.063-1.684 3.082-3.172 3.11v-.06c.273-.175.55-.46.61-.855h-.06a3.004 3.004 0 0 1-1.218 1.036v-.305c.207-.16.265-.406.422-.61.304-.406.855-.878 1.277-1.164v-.058h-.188c-.09.07-.257.058-.363.117-.207.117-.347.352-.55.484v-.117l.855-.914c.523-.394 1.3-.86 1.644-1.402.102-.305.207-.61.309-.914.188-.305.48-.621.61-.973h-.305c-.137.09-.66.008-.86-.058.024-.18.102-.079-.058-.188-.266.352-.473.215-.914.188v-.422h-.059c-.09.207-.187.238-.484.246v-.188c-.098-.02-.203-.039-.305-.058-.008-.137-.008-.168-.059-.246-.066.046-.097.046-.246.058v-.25c-.097-.02-.207-.035-.304-.055-.047-.128-.305-.652-.485-.789-.11-.09-.304-.058-.363-.191-.059-.113.07-.344.059-.363-.067-.11-.383-.274-.485-.364.04-.144.07-.187.117-.304-.343-.02-.46-.149-.492-.485a.898.898 0 0 0 .117-.246.713.713 0 0 1-.363-.484.936.936 0 0 0 .246-.188c-.219-.136-.387-.293-.422-.609h.364v-.059c-.207-.214-.305-.484-.305-.914.226.036.215.09.363.188-.16-.352-.246-.668-.246-1.219h.055c.082.098.039.067.191.113 0-.175 0-.336.059-.421v.058c.258.258.37.64.668.86-.149-.364-.305-.711-.364-1.165h.06v.118c.265.285.608.906.73 1.277h.058l-.25-1.277h.059v.117c.336.441.386 1.12.668 1.582.465.738 2.238 2.273 3.113 2.562.008-.375.113-.375.363-.484-.219-.5-.101-.344 0-.73-.07-.06-.191-.461-.117-.61.059-.02.117-.039.188-.058.011-.02-.04-.688 0-.79h.187c-.008-.273.012-.52.117-.668.07-.046.059-.035.188-.058.039.039.082.078.117.117v-.117c-.156-.203-.09-.383-.059-.668.118-.066.418-.18.485-.305-.168-.238-.067-.55 0-.855.039-.04.078-.082.117-.117.11.035.059.007.117.058.266.086.414.336.484.61h.055c-.078-.364-.144-.801-.055-1.223h.114v.059c.238.25.406.73.484 1.093h.059c-.012-.668.129-.992.246-1.457h.058c0 .574.18 1.016.364 1.399h.117c.156-.758.531-1.035.914-1.524h.059v.246c-.957 1.211-.844 4.34-.856 6.52h.059v-.117c.316-.418.304-1.118.609-1.528.148-.207.395-.273.61-.422.328-.234.554-.656.73-1.035h.058v.305c-.078.078-.078.11-.117.246h.117c.07-.047.06-.035.188-.059v.06c-.035.038-.078.081-.113.116h.113c.207.16.512.149.789.246v.059h-.187c-.06-.047-.02-.02-.118-.059v.059h.059c.102.09.285.137.363.25.11.156.09.5.246.61.328.234.485.117.73.484-.234-.012-.59-.032-.73.054.258 0 .375.051.555.118v.117l-.668.058c-.191.07-.277.364-.422.485-.445.37-1.332.351-1.344 1.16.336.543-.234 1.035-.421 1.281-.48.629-1.18 1.188-1.829 1.645-.277.195-.699.226-.789.609.02.023.036.04.059.059 1.016-.457 1.324-.782 2.613-.614zm0 0'});

    FE.RegisterCommand('insertSkoletube', {
        title: 'Skoletube',

        // This command doesn't change anything - simply opens a lightbox
        // overlay - so don't push to UI state
        focus: true,
        undo: false,
        refreshAfterCallback: false,

        callback: function () {
            modal.querySelector(".fr-modal-embed").innerHTML =
                '<iframe src="' + window.location.protocol + '//www.skoletube.dk/app/editorsup/?urlref=' + encodeURI(window.location) + '" width="100%" height="450" frameborder="0" allowTransparency="true" style="border:0;"></iframe>';

            modal.style.display = "block";
            overlay.style.display = "block";
        }
    });

}(jQuery));
